import keyMirror from 'keymirror';

import { EVENTS_TYPES } from '@/shared/Constants';

import { TooltipColors } from '@/components/tooltip/Tooltip';

export const goalSettingsActionTypes = keyMirror({
	GET_GOAL_SETTINGS_REQUEST: null,
	GET_GOAL_SETTINGS_SUCCESS: null,
	GET_GOAL_SETTINGS_ERROR: null,

	GET_GOAL_DURATIONS_REQUEST: null,
	GET_GOAL_DURATIONS_SUCCESS: null,
	GET_GOAL_DURATIONS_ERROR: null,

	GET_CURRENT_PRACTICE_REQUEST: null,
	GET_CURRENT_PRACTICE_SUCCESS: null,
	GET_CURRENT_PRACTICE_ERROR: null,

	SET_SELECTED_SUBJECT: null,
	SET_SELECTED_CATEGORY: null,
	SET_SELECTED_SUBCATEGORY: null,
	SET_SELECTED_DURATION: null,
	SET_CURRENT_PROGRESS: null,

	SAVE_GOAL_SETTING_REQUEST: null,
	SAVE_GOAL_SETTING_SUCCESS: null,
	SAVE_GOAL_SETTING_ERROR: null,

	TOGGLE_UNSAVED_CHANGES_MODAL: null,
	SET_PLAY_DAYS_PER_WEEK: null,
	SET_PLAY_MODE: null,
	SET_ACTIVE_EDIT_TARGET: null,
	RESET_SUBJECTS_TO_INITIAL: null,
	RESET_PRACTICE_TO_INITIAL: null,
	RESET_PLAY_MODE_TO_INITIAL: null,
});

export const SUBJECT_TYPES: Record<string, string> = {
	practice: 'practice',
	exam: 'exam',
};

export const STEP_PLAY_MODE = 'playMode';
export const STEP_PRACTICE = 'practice';
export const STEP_SUBJECTS = 'subjects';
export const STEP_SUMMARY = 'summary';
export const STEP_ENDSCREEN = 'endscreen';

export const STEPS: string[] = [
	STEP_PLAY_MODE,
	STEP_PRACTICE,
	STEP_SUBJECTS,
	STEP_SUMMARY,
	STEP_ENDSCREEN,
];

export const PRACTICE_SUB_STEPS = {
	PRACTICE_DURATION: 'practiceDuration',
	WEEK_PLANNING: 'weekPlanning',
} as const;

export const WEEKDAYS_NUMBER = 7;

export const RECOMMENDED_WEEKLY_PLAY_DAYS = 3;

export const DURATION_COLOR_LABELS: string[] = ['lavender', 'turquoise', 'yellow', 'orange'];

export const SUBJECT_NAMES_TO_EVENTS_MAP: Record<string, string> = {
	Rekenen: EVENTS_TYPES.GOAL_SETTINGS_MATH_VISITED,
	Taal: EVENTS_TYPES.GOAL_SETTINGS_LANG_VISITED,
	Toetsen: EVENTS_TYPES.GOAL_SETTINGS_EXAMS_VISITED,
};

export const STATUSES: Record<string, string> = {
	ACTIVE: 'active',
	DISABLED: 'disabled',
	HIDDEN: 'hidden',
	CHALLENGE: 'challenge',
};

export const WEEK_PLANNING_LABELS: Record<number, { color: TooltipColors; text: string }> = {
	1: { color: TooltipColors.PURPLE, text: 'goal_settings.week_planning.labels.days_1' },
	2: { color: TooltipColors.SEA, text: 'goal_settings.week_planning.labels.days_2' },
	3: { color: TooltipColors.ORANGE, text: 'goal_settings.week_planning.labels.days_3' },
	4: { color: TooltipColors.SEA, text: 'goal_settings.week_planning.labels.days_4' },
	5: { color: TooltipColors.PURPLE, text: 'goal_settings.week_planning.labels.days_5' },
	6: { color: TooltipColors.YELLOW, text: 'goal_settings.week_planning.labels.days_6' },
	7: { color: TooltipColors.YELLOW, text: 'goal_settings.week_planning.labels.days_7' },
};
